import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import { xpApi } from './xpApi';

export const watchTimeApi = createApi({
  reducerPath: 'watchTimeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['WatchTime'],
  endpoints: (builder) => ({
    getMyWatchStats: builder.query({
      query: () => '/watch-time/me',
      providesTags: ['WatchTime'],
    }),
    recordWatchTime: builder.mutation({
      query: ({ materialId, episode, secondsWatched }) => ({
        url: '/watch-time',
        method: 'POST',
        body: { material_id: materialId, episode, seconds_watched: secondsWatched },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(xpApi.util.invalidateTags(['XP']));
        } catch {}
      },
    }),
  }),
});

export const { useGetMyWatchStatsQuery, useRecordWatchTimeMutation } = watchTimeApi;
